module.exports = __webpack_public_path__ + "img/Kubel_0125_Eastern Spadefoot_website.7a28d227.jpg";